import { API_BASE_URL } from "../../helpers/apiBaseUrl";

const storedToken = () => {
  const value = localStorage.getItem("token") || sessionStorage.getItem("token");
  if (!value) return "";
  try { return JSON.parse(value); } catch { return value; }
};

export const dashboardInfoApi = async () => {
  const response = await fetch(`${API_BASE_URL}/dashboard`, {
    headers: { Accept: "application/json", Authorization: `Bearer ${storedToken()}` },
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(payload.message || "Unable to load the dashboard.");
  return payload;
};
